import { render } from "./tasksEditor.vue?vue&type=template&id=d52ec97c"
import script from "./tasksEditor.vue?vue&type=script&lang=js"
export * from "./tasksEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__